import { ColumnType } from './column-type';

/**
 * Représente les critères d'un des filtres saisies par l'utilisateur dans le tableau de résultat de la recherche.
 */
export class FilterCriteria {
    /**
     * Constructeur
     * @param type : Type de propriété à filtrer.
     * @param value :  Valeur du filtre.
     */
    constructor(
        public type: ColumnType,
        public values: string[]
    ) {}
}
